import { makeStyles } from "@material-ui/core/styles";

export default makeStyles(
  theme => ({
    accountName: {
      "& .MuiListItemText-primary": {
        fontSize: 18,
        fontWeight: 600
      },
      "& .MuiListItemText-primary, .MuiListItemText-secondary": {
        display: "block",
        maxWidth: 260,
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
      },
      maxWidth: "55vw"
    },
    accountsList: {
      gridRowGap: 0
    },
    dialog: {
      borderRadius: 10,
      display: "block",
      maxWidth: 360
    },
    dialogActions: {
      borderTop: "none",
      justifyContent: "space-between",
      paddingBottom: 30
    },
    dialogCloseButton: {
      position: "absolute",
      right: 8,
      top: 8
    },
    dialogContent: {
      overflow: "hidden",
      paddingBottom: 18,
      paddingTop: 10
    },
    dialogForgotPassword: {
      color: "#247CFF",
      cursor: "pointer",
      fontSize: 14
    },
    dialogLoginButton: {
      "& .MuiButton-label": {
        color: "#FFFFFF"
      },
      "&:hover": {
        backgroundColor: "#ACCAFF"
      },
      "&:hover .MuiButton-label": {
        color: "#0030FF"
      },
      backgroundColor: "#1848FE",
      paddingLeft: 40,
      paddingRight: 40
    },
    dialogPassword: {
      "& .MuiOutlinedInput-root": {
        borderRadius: 8
      }
    },
    dialogSelectedAccount: {
      color: "#0030FF",
      fontSize: 23,
      fontWeight: 700,
      marginBottom: 25,
      textAlign: "center"
    },
    dialogTitle: {
      border: "none"
    },
    dialogTitleText: {
      fontSize: 18,
      fontWeight: 600
    },

    dialogWelcome: {
      fontSize: 14,
      textAlign: "center"
    },

    header: {
      color: "#0030FF",
      fontSize: 25,
      fontWeight: 600,
      marginBottom: 20,
      textAlign: "center"
    },
    loginCard: {
      [theme.breakpoints.up("sm")]: {
        maxWidth: 422
      },
      margin: "0 auto",
      width: "100%"
    },
    loginExisting: {
      "& .MuiButton-label, .MuiButton-startIcon": {
        color: "#247CFF",
        fontSize: 17,
        fontWeight: 500
      },
      "&:hover": {
        backgroundColor: "#F4F8FF"
      },
      marginLeft: 9,
      textTransform: "none"
    },
    loginWrapper: {
      display: "flex",
      flexDirection: "column",
      height: "100vh",
      justifyContent: "center",
      padding: "3em 16px",
      width: "100vw"
    },
    logo: {
      margin: "20px auto",
      width: 65
    },
    savedAccountContent: {
      "&:hover": {
        background: "none"
      }
    },
    savedAccountItem: {
      borderRadius: 8,
      paddingBottom: 0,
      paddingLeft: 8,
      paddingTop: 0
    },
    savedAccountItemButton: {
      right: 0
    },
    savedAccountItemContainer: {
      "&:hover": {
        backgroundColor: "#F4F8FF",
        borderRadius: 8
      },
      "&:hover .MuiListItemSecondaryAction-root > span": {
        display: "none"
      },
      "&:hover .MuiListItemSecondaryAction-root button": {
        display: "block"
      }
    },
    signUpLabel: {
      color: "#247CFF"
    },
    signUpLink: {
      textDecoration: "none"
    },
    signUpWrapper: {
      margin: "20px auto"
    },
    signedOutText: {
      color: "#747C8C",
      float: "right",
      fontSize: 13,
      marginTop: 10
    },
    subHeader: {
      color: "#BEBEBE",
      fontSize: 12,
      fontWeight: 600,
      letterSpacing: "0.15em",
      paddingLeft: 8
    },
    trashButton: {
      "&:hover": {
        backgroundColor: "transparent"
      },
      color: "#0030FF",
      display: "none",
      transition: `opacity ${theme.transitions.duration.shorter}ms`
    }
  }),
  {
    name: "LoginSavedAccount"
  }
);
